const en = {
  AuthTitle: {
    Greetings: "Welcome to",
  },
  Auth: {
    EnterEmail: "Enter email",
    EnterPassword: "Enter password",
    AgreeWith: "I agree with",
    ProcessingPersonalData: "the processing of personal data",
    UserAgreement: "the user agreement",
    EmailRequiredError: "Email required",
    EmailWrongFormatError: "Wrong email format!",
    PasswordRequiredError: "Password required",
    ForgotPassword: "Forgot password",
  },
  Login: {
    Title: "Login",
    Subtitle: "Complete the fields below to log into your account.",
    Login: "Login",
    Register: "Registration",
    LoginError: "Incorrect login or password entered",
    BuyTeacherLessons: "Buy lessons with a teacher",
  },
  Register: {
    Title: "Registration",
    Subtitle: "Complete the fields below to register your account.",
    Register: "Register",
    Login: "Login",
    EnterLastName: "Enter last name",
    EnterFirstName: "Enter a name",
    EnterEmail: "Enter email",
    EnterGender: "Gender",
    EnterBirthday: "Date of birth",
    EnterProfileCountryId: "Citizenship",
    EnterProfileCityId: "Host city",
    EnterProfileDegreeId: "Education",
    EnterPassword: "Enter password",
    RepeatPassword: "Repeat password",
    LastNameRequiredError: "Lastname is required",
    LastNameMinLengthError: "Minimum 2 characters",
    FirstNameRequiredError: "Name is required",
    FirstNameMinLengthError: "Minimum 2 characters",
    PhoneRequiredError: "Phone is required",
    PhoneInvalidError: "Incorrect phone format",
    GenderRequiredError: "Gender is required",
    BirthdayRequiredError: "Date of birth is required",
    ProfileCountryIdRequiredError: "Citizenship is required",
    ProfileCityIdRequiredError: "Host city is required",
    ProfileDegreeIdRequiredError: "Education is required",
    PasswordMismatchError: "Passwords do not match",
    PasswordMinLengthError: "Minimum 6 characters",
  },
  Reset: {
    Title: "Password Reset",
    Subtitle:
      "Enter the email you provided during registration and click the 'Reset' button",
    Reset: "Reset",
    Login: "Login",
    Success:
      "In a few minutes, you will receive an email to <0>{{email}}</0> with instructions on how to reset your password.",
  },
  CookieNotice: {
    Message:
      "We use cookies to improve the site and its user experience. By continuing to use the site, you consent to the use of cookies. You can always disable cookies in your browser settings.",
    Agree: "Accept, don't show again",
  },
  MainPage: {
    Title: "Main",
    TitleGreetings: "Welcome to",
    TitleGreetingsMiddle: "GOVORI",
    TitleGreetingsEnd: "RU!",
    MyCourses: "My Courses",
    CourseContinue: "CONTINUE",
    CourseCountStart: "Available",
    CourseCount_one: "{{count}} course",
    CourseCount_other: "{{count}} courses",
    AllCourses: "All courses",
    MyLessons: "My lessons",
    AllLessons: "all lessons",
    EmptyCourses: "No courses",
    EmptyLessons: "No lessons",
    BuyTeacherLessons: "Buy lessons with a teacher",
    BuyTeacherLessonsLink: "here",
    ForeignCardTooltip: "For cards issued outside the Russian Federation",
    NoActiveLicense: "You do not have an active license.",
    GoIntoLesson: "Go to lesson",
    FinishedLessons: "Finished",
    CanceledLessons: "CANCELED",
  },
  CoursesPage: {
    Title: "My courses",
    TitleGreetings: "Welcome to",
    MyCourses: "My Courses",
    CourseContinue: "CONTINUE",
    EmptyCourses: "No courses",
    SearchPlaceholder: "Search by title",
    LevelPlaceholder: "Level",
    AllLevels: "All levels",
  },
  Menu: {
    Main: "Main page",
    Words: "Words",
    Courses: "My Courses",
    Lessons: "Lessons with a teacher",
    TeacherCorner: "Teacher Corner",
    AdditionalCourses: "Additional courses",
    UsefulLinks: "Useful Links",
    Notifications: "Notifications",
    Video: "Video",
    TeacherGroups: "Groups",
    TeacherAttendance: "Attendance",
    TeacherClasses: "Classes",
    TeacherReports: "Reports",
    CreativeTasks: "Creative tasks",
    Attendance: "Attendance",
  },
  Footer: {
    Copyright: "All rights reserved",
    About: "About the company",
    PrivacyPolicy: "Data usage policy",
    PrivacyProtect: "Personal data processing and protection regulation",
  },
  Module: {
    exercise_one: "exercise",
    exercise_few: "exercises",
    Completed: "Completed",
    Result: "Result",
    InWork: "In progress",
    Done: "Finished",
  },
  SteppedProgress: {
    Completed: "Completed",
  },
  CourseDetails: {
    Title: "Course information",
    Progress: "Progress",
    Completed: "DONE",
    Result: "RESULT",
    Hours: "Hours",
    Lessons: "Lessons",
    Units: "Units",
    Unit: "Unit",
    Exercises_zero: "{{count}} exercises",
    Exercises_one: "{{count}} exercise",
    Exercises_other: "{{count}} exercises",
    Exercises_many: "{{count}} exercises",
  },
  CourseUnitDetails: {
    Vocabulary: "Words",
    Video: "Video",
    Grammar: "Grammar",
    Reading: "Reading",
    Writting: "Writting",
    Speaking: "Speaking",
    Test: "Test",
    Unknown: "Unknown",
    EmptyExercises: "No exercises",
  },
  EntranceTest: {
    ModalTitle: "Determine your level of knowledge",
    ModalBody:
      "Take the test to determine your level of Russian language proficiency. The test takes an average of 40 minutes.",
    Cancel: "Cancel",
    Take: "Take the test",
  },
  TeacherPage: {
    Title: "Main teacher",
    MyLessons: "My Lessons",
    MyModules: "My modules",
  },
  DistributorPage: {
    Title: "Main Distributor",
  },
  CoordinatorPage: {
    Title: "Main Coordinator",
  },
  Button: { Send: "Send", Download: "Download" },
  Distributor: {
    Report: "Reports",
    DateFrom: "From date",
    DateTo: "To date",
    Status: "Status",
    StatusReady: "Ready",
    StatusPlanned: "Pending",
    Actions: "Actions",
    FromRequiredError: "Specify the start date",
    ToRequiredError: "Specify the end date",
  },
  LessonsTable: {
    GroupName: "Groups",
    Status: "Status",
    StartDateTime: "Date and time",
    Duration: "Ah",
    Credentials: "Webinar: Login/Password",
    CredentialsCopied: "Copied!",
    SortAlpabetically: "Alphabetically A-Z",
  },
  LessonStatuses: {
    completed: "Completed",
    planned: "planned",
    earlyCanceledByCustomer: "Cancelled by listeners",
    earlyCanceledBySchool: "Teacher Canceled",
    lateCanceledByCustomer: "Canceled by listeners",
    lateCanceledBySchool: "Teacher Canceled",
  },
  LessonAttendance: {
    Status: "Select status",
    Date: "Select date",
    Time: "Select time",
    Duration: "Duration",
    AH: "a.h",
    Students: "Students",
    CheckAll: "Check all",
    Comment: "Comments",
    Submit: "Submit",

    restrictiveBackDateError: "Date cannot be less than allowed",
    restrictiveForwardDateError: "Date cannot be more than allowed",
    commentSizeError: "Comment must be less than {{count}} words",
    requiredFieldError: "This field is required",
    requiredDateError: "Fill date and time",
    ExcessHoursWarning: "The number of hours is exceeded",
    MarkStudents:
      "Mark the students who attended the class and save the changes.",

    apiError:
      "Your data isn't saved. Please contact tech support online@dschool.ru",
    early_cancel_by_customer_not_acceptable:
      "Early cancellation by user is not available, 2 classes have already been cancelled, contact the coordinator",
    early_cancel_by_school_not_acceptable:
      "Early cancellation by the school is not available, 2 classes have already been cancelled, contact the coordinator",
  },
  TeacherReportsPage: {
    Title: "Reports",
    HeaderTitle: "Reports",
    CreateReport: "Create report",
  },
  TeacherReportTable: {
    Title: "Report title",
    CreationDate: "Creation date",
    Period: "Period",
    Status: "Status",
    StatusDone: "Done",
    StatusPending: "Pending",
    Actions: "Actions",
    Statistics: "Platform statistics",
    CourseProgress: "Course progress",
    ActiveTime: "Time on platform report",
    EntranceTest: "Entrance testing",
    LecenseReport: "Used licenses report",
    HeaderTitle: "Reports",
    CreateReport: "Create report",
    DeleteReport: "Are you sure?",
    DeleteTooltip: "Remove",
    MailTooltip: "Send to email",
    DownloadTooltip: "Download",
    DeleteGroupTooltip: "Remove selected",
    MailGroupTooltip: "Send selected to email",
    DownloadGroupTooltip: "Download selected",
  },
  CreateReportForm: {
    Statistics: "Platform statistics",
    CourseProgress: "Course Progress",
    ActiveTime: "Time on platform report",
    Report: "My report",
    Title: "Create report",
    Type: "Report type",
    TypeLabel: "Type",
    NameLabel: "Title",
    DateLabel: "Date",
    DateFromLabel: "From",
    DateToLabel: "To",
    Name: "Report name",
    Period: "Period",
    PeriodFrom: "From",
    PeriodTo: "To",
    Date: "Date",
    FilterListGroup: "Group",
    FilterListStudent: "Student",
    FilterListCompany: "Customer company",
    FilterListTest: "Entrance test name",
    FilterListSelectedStudents: "Group filter, selected {{count}} students",
    FilterListSelectedGroups: "Group filter, selected {{count}} groups",
    FilterListCompanies: "Group filter, selected {{count}} companies",
    FilterListSelectedTests: "Group filter, selected {{count}} entrance tests",
    FilterListSelectedPlaceholderStudents: "Select students",
    FilterListSelectedPlaceholderGroups: "Selected groups",
    FilterListSelectedPlaceholderCompanies: "Selected customer companies",
    FilterListSelectedPlaceholderTests: "Select entrance tests",
    GroupsChosen: "Selected groups",
    ChooseAll: "Select all",
    RemoveAll: "Remove all",
    GroupName: "Group",
    GroupDefault: "Group default",
    Cancel: "Cancel",
    Create: "Create",
    TitleRequiredError: "Name is required",
    FromRequiredError: "Period start date is required",
    ToRequiredError: "Period end date is required",
    GroupsRequiredError: "Select one or more groups!",
    OrderCreateError: "Failed to create new report",
    FieldRequiredError: "Field is required",
    NoItems: "No groups",
  },
  Gender: {
    Male: "Male",
    Female: "Female",
  },
  Role: {
    student: "Student",
    teacher: "Teacher",
    distributor: "Distributor",
    coordinator: "Coordinator",
  },
  EmailNotConfirmed: {
    Title:
      "To enter the platform, an email has been sent to your email address, {{email}}. Please confirm your address. If you have any questions, write online@dschool.ru",
    Back: "<< Back",
  },
  MyWordsPage: {
    Title: "My words",
    EmptyWordList:
      "There are no words for learning. Select another unit in filters",
  },
  WordsFilter: {
    Title: "Filters",
    Clear: "Clear",
    EmptyCourses: "Empty courses",
    ChooseCourse: "Choose course",
    ChooseUnit: "Choose unit",
    EmptyUnits: "Empty units",
  },
  SetupPassword: {
    Title: "Password setup",
    Subtitle:
      "You need to set a new password, enter the new password and confirmation in the fields below",
  },
  SetupPasswordRedirect: {
    Title: "Action required",
    Description: "You must set a password to continue using this service.",
    Redirect: "Set password",
  },
  ChangePassword: {
    Password: "Password",
    PasswordRepeat: "Password repeat",
    Confirm: "Confirm",
    PasswordShortError: "Password length must be greater than 6 characters",
    PasswordMismatch: "Passwords must match",
    Success: "Password successfully changed",
    Login: "Back to login page",
  },
  ProfilePage: {
    Title: "My Profile",
  },
  Profile: {
    PersonalData: "Personal information",
    FirstName: "Name",
    LastName: "Last name",
    BirthDate: "Date of birth",
    Citizenship: "Citizenship",
    Degree: "Education",
    City: "City of arrival",
    NewPassword: "New password",
    ConfirmNewPassword: "Confirm new password",
    Password: "Password",
    Save: "Save",
    DataUpdateSuccess: "Data updated successfully",
    Settings: "Settings",
    ShowPassingResults: "Display the result of the passage",
  },
  UsefulLinks: {
    Title: "Useful links",
    GroupName: "Group name:",
    Added: "Added",
    NoLinks: "No links",
  },
  DatePicker: {
    Today: "Today",
    Clear: "Clear",
  },
  Promocode: {
    Expired:
      "Enrollment in the group has been discontinued. Contact your manager",
  },
  TeachersAutocompleteFilter: {
    EnterTeacherName: "Teachers not found",
    SelectTeacher: "Teacher select",
  },
  Loading: {
    Error: "Loading error, try refreshing the page",
  },
  MultipleSelect: {
    SelectAll: "Select all",
  },
  Attendance: {
    Title: "Attendance",
  },
  CreativeTasks: {
    Title: "Creative Tasks",
  },
};

export default en;
